import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import OffboardingOutlet from "../features/offboarding/pages/OffboardingOutlet/OffboardingOutlet";
import StepDeparture from "../features/offboarding/pages/StepDeparture/StepDeparture";
import StepJustificatif from "../features/offboarding/pages/StepJustificatif/StepJustificatif";
import StepSolde from "../features/offboarding/pages/StepSolde/StepSolde";
import StepEquipments from "../features/offboarding/pages/StepEquipments/StepEquipments";
import StepTasks from "../features/offboarding/pages/StepTasks/StepTasks";

/* Preaparer un offboarding */
export const prepareOffboardingRoutes = (
    <Route
        path={ROUTES.offboarding.prepare_offboarding}
        element={<OffboardingOutlet />}
        key="prepare_offboarding"
    >
        <Route index path="" element={<StepDeparture />} />
        <Route path="departure" element={<StepDeparture />} />
        <Route path="justification" element={<StepJustificatif />} />
        <Route path="leave_balances" element={<StepSolde />} />
        <Route path="equipments_access" element={<StepEquipments />} />
        <Route path="attribute_tasks" element={<StepTasks />} />
    </Route>
);
